const translationPath =
  "page.4uSalesContract.registers.beneficiaryClassification.";

export const buildTPath = (path: string) => translationPath + path;
